import {generateCdnProxyImageUrl} from "./helpers";
import {baseSportsIndexDomain} from "./request";
import {IProvider} from "./types";

export enum ProviderIds {
  BET365 = 1
}

export enum LogoType {
  SQUARE = 'square',
  LIGHT = 'light',
  DARK = 'dark'
}

export function getProviderImageUrl(provider: IProvider | null, logoType: string | null = null) {
  if (logoType === LogoType.LIGHT)
    return getLightProviderImageUrl(provider);
  else if (logoType === LogoType.SQUARE)
    return getSquareProviderImageUrl(provider);

  return getDarkProviderImageUrl(provider);
}

export function getDarkProviderImageUrl(provider: IProvider | null) {
  return provider ? generateCdnProxyImageUrl(baseSportsIndexDomain + provider.logoUrl) : '';
}

export function getLightProviderImageUrl(provider: IProvider | null) {
  return provider ? generateCdnProxyImageUrl(baseSportsIndexDomain + provider.lightLogoUrl) : '';
}

export function getSquareProviderImageUrl(provider: IProvider | null) {
  return provider ? generateCdnProxyImageUrl(baseSportsIndexDomain + provider.squareLogoUrl) : '';
}

